import { infer as Infer, z } from 'zod';

export const quizSectionSchema = z.object({
  id: z.uuid(),
  name: z.string().min(1, 'Nazwa nie może być pusta').max(128, 'Nazwa nie może przekraczać 128 znaków'),
  content: z.string().max(4096, 'Treść nie może przekraczać 4096 znaków').optional(),
  time: z.number().min(0, 'Czas musi być liczbą nieujemną').max(3600, 'Czas nie może przekraczać 1 godziny').optional(),
});

export type QuizSectionSchema = Infer<typeof quizSectionSchema>;
